import PropTypes from 'prop-types'
import IAction from './IAction'

class Action extends IAction {
	fn() {
		return this.props.onClick
	}

	icon() {
		return this.props.icon
	}

	title() {
		return this.props.notifs
	}

    title() {
		return this.props.title
	}

	component() {
		return this.props.component
	}
}

Action.propTypes = {
	onClick: PropTypes.func.isRequired,
    notifs: PropTypes.number,
	icon: PropTypes.string,
	title: PropTypes.string,
	component: PropTypes.element
}

export default Action



// WEBPACK FOOTER //
// ./src/components/actions/Action.js